import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateNewProduct } from "../../features/product/productSlice";

export function useImageUpload() {
    const dispatch = useDispatch();
    const [previewUrl, setPreviewUrl] = useState<string>('');
    const [file, setFile] = useState<File | null>(null);

    const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0];
        if (!selected) return;

        const reader = new FileReader();
        reader.readAsDataURL(selected);

        reader.onloadend = () => {
            const result = reader.result as string;
            setPreviewUrl(result);
            dispatch(updateNewProduct({ image: result }));
        };

        setFile(selected);
    };

    return { previewUrl, file, handleUpload };
}